import { memo } from 'react';
function DropElementsBox({ title = '' }) {
  return <div className="drop-elements-box">{title}</div>;
}
export default memo(DropElementsBox);
